<template>
    <main-content with_go_back_bar>
        <manage-application-details v-if="$can('read', 'open-banking')"></manage-application-details>
        <common-application-details v-else-if="is_authenticated" ></common-application-details>
    </main-content>
</template>

<script>
import mainContent from '@/components/main-content'
import ManageApplicationDetails from './components/manage-access/application-details.vue'
import CommonApplicationDetails from './components/common-access/application-details'
import {mapGetters} from "vuex";

export default {
    components: {
        'main-content': mainContent,
        'manage-application-details': ManageApplicationDetails,
        'common-application-details': CommonApplicationDetails,
    },
    data() {
        return {
            headerAction: {
                left: '10px',
                top: '10px',
                position: 'absolute'
            },
        }
    },
    computed: {
        ...mapGetters('user', [
            'is_authenticated'
        ]),
    },
}
</script>

<style>
.switch-div {
    width: fit-content;
    padding: 8px 27px;
    background: #fff;
    box-shadow: 0 0 7px 0 #9c9c9c5e;
}
.switch {
    position: relative;
    display: inline-block;
    width: 60px;
    height: 20px;
}

/* Hide default HTML checkbox */
.switch input {
    opacity: 0;
    width: 0;
    height: 0;
}

/* The slider */
.slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #6aad27;
    -webkit-transition: .4s;
    transition: .4s;
}

.slider:before {
    position: absolute;
    content: "";
    height: 12px;
    width: 26px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    -webkit-transition: .4s;
    transition: .4s;
}

input:checked + .slider {
    background-color: #2196F3;
}

input:focus + .slider {
    box-shadow: 0 0 1px #2196F3;
}

input:checked + .slider:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
}
.slider.round {
    border-radius: 50px;
}

.slider.round:before {
    border-radius: 50px;
}

.info-icon {
    cursor: pointer;
    color: #0f9af0;
    display: inline-block;
}
</style>